import React, { Component, Fragment } from 'react';
import CompanyHeader from 'containers/CompanyContainer/CompanyHeader';
import ProviderContainer from 'containers/CompanyContainer/ProviderContainer';
import ClientsContainer from 'containers/CompanyContainer/ClientsContainer';
import CompanyPageButton from 'containers/CompanyContainer/CompanyPageButton';
import {
    BrowserRouter as Router,
    withRouter,
    Link,
    Redirect,
} from 'react-router-dom';
import CompanyPageLink from 'containers/CompanyContainer/CompanyPageLink';
import styled from 'styled-components';
import firebase from '../../firebase/firebase';
import AdminSetupForm from 'containers/CompanyContainer/AdminSetupForm';
import CompanySetupForm from 'containers/CompanyContainer/CompanySetupForm';
import EmployeeSetupForm from 'containers/CompanyContainer/EmployeeSetupForm';
import ServiceSetupForm from 'containers/CompanyContainer/ServiceSetupForm';
import AdminContainer from 'containers/CompanyContainer/AdminContainer';

import ZenDeskChat from '@inlightmedia/react-zendesk-chat';

// REDUX
import { connect } from 'react-redux';
import * as actions from 'actions';
import CompanyNotification from 'containers/CompanyContainer/CompanyNotification';

// Constants
import { constants } from 'constants/index';
import FlexColumn from 'components/Primatives/FlexColumn';
import H2 from 'components/Primatives/H2';

const ButtonWrapper = styled.div`
    text-align: right;
    margin-right: 5%;
    margin-top: 25px;
`;
const db = firebase.database();

class CompanyContainer extends Component {
    componentWillMount() {
        localStorage.clear();
        let {
            getServices,
            getCompanyInfo,
            resetSelections,
            userData,
        } = this.props;
        getServices();
        resetSelections();
        if (userData.providerCompany !== undefined) {
            getCompanyInfo(userData.providerCompany);
            const messageQueueRef = db.ref(
                `providerCompanies/${userData.providerCompany}/messageQueue/`,
            );
            messageQueueRef.on('value', queueSnap => {
                queueSnap.forEach(messageSnap => {
                    var childKey = messageSnap.key;
                    var childData = messageSnap.val();
                    this.props.sendCompanyNotification({
                        message: childData.message,
                        title: childData.title,
                        type: childData.type,
                        companyId: userData.providerCompany,
                        messageId: messageSnap.key,
                    });
                    getCompanyInfo(userData.providerCompany);
                });
            });
        }
    }

    render() {
        if (
            this.props.userData &&
            this.props.userData.providerCompany === undefined
        ) {
            return <Redirect to="/company/adminSetup" />;
        }

        let {
            companyInfo,
            providerInfo,
            providers,
            userData,
            authData,
            accountAdmins,
            staffAdmins,
        } = this.props;
        companyInfo
            ? null
            : (companyInfo = {
                  name: '',
                  logoURL: '',
                  uid: '',
                  pendingAccounts: {},
                  clients: {},
              });

        const isAbleToAddServices = providers =>
            providers.length === 0 ? false : true;

        const buttonStyles = {
            background: constants.color.grey5,
            color: constants.color.grey34,
        };

        // let addButtonContent;
        // isAbleToAddServices(providers)
        //     ? (addButtonContent = 'Add new services')
        //     : (addButtonContent = (
        //           <CompanyPageLink
        //               type={'button'}
        //               label={'Add new services'}
        //               destination={`/company/serviceEditor`}
        //           />
        //       ));

        const { pendingAccounts, clients, isDialogOpen } = companyInfo;
        let isAdmin = userData.roles ? userData.roles.accountAdmin : false;

        // Makes sure that the Zendesk chat element only adds once
        const zopim = !!document.getElementsByClassName('zopim')[0];
        if (!userData.roles.accountAdmin && !userData.roles.staffAdmin) {
            return (
                <FlexColumn
                    style={{
                        backgroundColor: constants.color.grey5,
                        maxWidth: 'none',
                        alignSelf: 'stretch',
                        alignItems: 'center',
                    }}
                >
                    <H2>
                        You do not have the proper permissions to access this
                        part of the site. Only staff administrators and account
                        administrators can access this page.
                    </H2>
                </FlexColumn>
            );
        } else {
            return (
                //<AdminSetupForm userData={authData}/>
                //<CompanySetupForm />
                //<EmployeeSetupForm/>
                //<ServiceSetupForm/>
                <Fragment>
                    {!zopim && (
                        <ZenDeskChat appID="66a9qMyMcQRkCB3P7UTGPPphKFikXpjD" />
                    )}
                    <CompanyHeader
                        title={companyInfo.name}
                        logo={companyInfo.companyLogo}
                        uid={companyInfo.uid}
                        isAdmin={isAdmin}
                    />
                    <ClientsContainer
                        pendingAccounts={pendingAccounts}
                        clients={clients}
                    />
                    <ButtonWrapper>
                        <CompanyPageButton
                            type={'dark'}
                            children={'Add new service'}
                            onClick={() => {
                                if (isAbleToAddServices(providers)) {
                                    this.props.history.push(
                                        `/company/serviceEditor`,
                                    );
                                    this.props.updateLocation(
                                        `/company/serviceEditor`,
                                    );
                                }
                            }}
                            buttonStyle={
                                isAbleToAddServices(providers)
                                    ? buttonStyles
                                    : {}
                            }
                        />
                        <CompanyPageButton
                            type={'dark'}
                            onClick={() => {
                                this.props.history.push(
                                    `/company/employeeEditor`,
                                );
                                this.props.updateLocation(
                                    `/company/employeeEditor`,
                                );
                            }}
                            children={'Add new employee'}
                        />
                    </ButtonWrapper>
                    <AdminContainer
                        staff={accountAdmins}
                        title={'Account Administrators'}
                    />
                    <AdminContainer
                        staff={staffAdmins}
                        title={'Staff Administrators'}
                    />
                    <ProviderContainer staff={providers || []} />
                    <CompanyNotification />
                </Fragment>
            );
        }
    }
}

const mapStateToProps = ({ auth, company, router, client }) => ({
    providers: company.providers,
    accountAdmins: company.accountAdmins,
    staffAdmins: company.staffAdmins,
    companyInfo: company.companyInfo,
    providerInfo: company.providerInfo,
    services: company.services,
    authData: auth.authData,
    userData: client.clientData,
    userId: auth.authData ? auth.authData.id : null,
    location: router.location,
});

export default withRouter(
    connect(
        mapStateToProps,
        actions,
    )(CompanyContainer),
);



// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/index.jsx